<template>
  <!-- 远程控制 -->
  <div class="FilesManage">
    <div class="con">
      <div class="left-tree">
        <elAreaTree :dataList='dataList'></elAreaTree>
      </div>
      <div class="right-table">
        <div class="content">
          <div class="Files-top">
            <div class="ic-left">
              <span>水表状态</span>
            </div>
            <div class="btns">
              <el-button type="primary" @click="getList">新增</el-button>
              <el-button type="primary" class="last-el-button">导出</el-button>
            </div>
          </div>
          <div class="search-input-btn" style="width:100%">
            <div class="input-small mr-20">
              <span>表编号：</span>
              <el-input v-model="deviceNo" style="width: 160px;"></el-input>
            </div>
            <div class="input-small mr-20 myinput">
              <span>阀门状态：</span>
              <el-select v-model="state232" clearable placeholder="请选择" style="width: 160px;">
                <el-option v-for="item in gateOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small mr-20 myinput">
              <span>通讯状态：</span>
              <el-select v-model="deviceState" clearable placeholder="请选择" style="width: 160px;">
                <el-option v-for="item in deviceStateList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small mr-20">
              <span>开始时间：</span>
              <el-date-picker v-model="timerValue" type="datetime" placeholder="选择开始时间" align="right"
                :picker-options="pickerOptions" style="width: 180px;"> </el-date-picker>
            </div>
            <div class="input-small">
              <span>结束时间：</span>
              <el-date-picker v-model="timerValue" type="datetime" placeholder="选择结束时间" align="right"
                :picker-options="pickerOptions" style="width: 180px;"> </el-date-picker>
            </div>
            <el-button type="primary" plain @click="getList" class="search-btn">查询</el-button>
          </div>
          <div class="Files-table" :style="{'height':heights+'px'}">
            <el-table :data="tableData" stripe style="width: 100%" :max-height="heights - 20">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column label="序号" width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="deviceNo" label="表编号" width="228"> </el-table-column>
              <el-table-column prop="realElectricQuantity" label="抄表读数" width="228" align="right"> </el-table-column>

              <el-table-column label="阀门状态" align="center" width="228">
                <template #default="{row}">
                  <!-- <span>{{row.state232?'开闸':'关闸'}}</span> -->
                  <div class="state-row open-state" v-if="row.state232">
                    <span></span>开闸
                  </div>
                  <div class="state-row close-state" v-else>
                    <span></span>关闸
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="通信状态" align="center" width="228">
                <template #default="{row}">
                  <div style="display:flex;align-items: center;justify-content: center;">
                    <img src="../../assets/unifyImg/onLine.png" alt="" v-if="row.deviceState == 1">
                    <img src="../../assets/unifyImg/offline.png" alt="" v-else>
                    <span
                      :style="{'marginLeft':'10px','color':row.deviceState == 1?'#0DAE88':'#999999'}">{{row.deviceState
                      | date_deviceState}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="查询时间">
                <template #default="{row}">
                  <span>{{row.queryTime | date_format}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="divider-line"></div>
          <div class="paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import elAreaTree from '@/components/module/newTree/elAreaTree.vue'
  import {getWaterCurrentState} from "../../api/zhongshanMeter";
  export default {
    components: {
      elAreaTree
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-290,//屏幕高度 - 导航栏高度
        deviceNo: "",//表编号
        tableData: [],
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        timerValue: "",
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        gateOptions: [
          {
            name: "开",
            id: 1
          },
          {
            name: "关",
            id: 0
          },
        ],//阀门状态
        state232: "",
        deviceStateList: [
          {
            name: "在线",
            id: 1
          },
          {
            name: "离线",
            id: 0
          },
        ],//通讯状态
        deviceState: "",
        typeList: [],
      };
    },
    computed: {
      dataList () {
        var data=this.$store.unitStore.getters.getAreaTree
        return isempty(data)? []:[deviceList(data)]
      },
      nowArea () {
        var data=this.$store.cacheStore.state.setBuilding
        console.log(data);
        return data
      }

    },

    mounted () {
      this.getList()
    },
    watch: {
      dataList (v) {
        // console.log("侦听器",v);
      },
      nowArea () {
        this.getList()
      }
    },

    methods: {
      //获取数据
      getList () {
        var obj={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'areaId': this.nowArea.id,
          'deviceNo': this.deviceNo,
          'deviceState': this.deviceState,
          'state232': this.state232
        }
        let d={};
        for(let key in obj) {
          // 如果对象属性的值不为空，就保存该属性（如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
          if((obj[key]===0||obj[key])&&obj[key].toString().replace(/(^\s*)|(\s*$)/g,'')!=='') {
            // 保存属性
            d[key]=obj[key];
          }
        }


        this.loading=true
        getWaterCurrentState(d).then(res => {
          this.tableData=[]
          if(res.code==200) {

            this.total=res.data.numberResult.total
            var data=res.data.dataResult.dataList
            for(let k in data) {
              this.tableData.push(data[k])
            }
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查看失败')
            this.loading=false
          }
        })
      },
      //分页功能
      newgetNowPageDataList () {
        this.getList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
      //校验阀门状态
      date_state232 (val) {
        if(val==0) {
          return "关"
        } else if(val==1) {
          return "开"
        } else {
          return ""
        }
      },
      //校验通讯状态
      date_deviceState (val) {
        if(val==0) {
          return "离线"
        } else if(val==1) {
          return "在线"
        } else {
          return ""
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {

    display: flex;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      padding-top: 20px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .input-small span {
      white-space: nowrap;
    }

    .el_Tree_Body {
      border: 0px;
    }

    /deep/.search-input-btn .el-select .el-input__inner {
      width: 1.6rem;
    }

    .search-input-btn .input-small .el-input__inner {
      width: 1.6rem;
    }

    /deep/.search-input-btn .myinput .el-input {
      width: 1.6rem;
    }

    .right-table {
      width: calc(100% - 3.08rem);
      background-color: #fff;
      padding: 20px 20px 12px 20px;
      box-sizing: border-box;

      .Files-table {


        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .state-row {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            display: inline-block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            margin-right: 10px;
            position: relative;
            top: -1px;
            border: 4px solid transparent;
          }
        }

        .open-state {
          color: #0DAE88;

          span {
            background-color: #0DAE88;
            border-color: #B0FFED;
          }
        }

        .close-state {
          color: #FF1D1D;

          span {
            background-color: #FF1D1D;
            border-color: #FFD7D7;
          }
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }




  }

  /deep/.el-tree-node__content {
    width: 3rem;
  }
</style>